import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';

import {Title} from '@angular/platform-browser';
import { FormBuilder, Validators,FormArray,FormControl } from '@angular/forms';
import { ActivityService } from '../../common/activity.service';
import {ListingService } from '../listing.service';

@Component({
  selector: 'app-admin-full-cancel',
  templateUrl: './admin-full-cancel.component.html',
  styleUrls: ['./admin-full-cancel.component.css', '../../app.component.css', '../admin.css'],
  providers: [ListingService,ActivityService]

})
export class AdminFullCancelComponent implements OnInit {
  userId : any;
  eventId :any;
  userType :any;
  spinner: boolean = false;
  users: any;
  rList: any;
  discount:any;
  errorMessage:any;
  cancelForm:any;
  cardPaid:any;
  TotalCardPaid:any;
  checkPaid:any;
  TotalCheckPaid:any;
  isChecked:any;
  resultArray:Array<any>=[];
  totalPrice:any;
  eventUserId:any;
  isRefundRadio:any;
  constructor(private router: Router, public dialogRef: MdDialogRef<AdminFullCancelComponent>, private snackBar: MdSnackBar,private formBuilder: FormBuilder, private ListingService: ListingService,private ActivityService: ActivityService) {
    this.cancelForm = this.formBuilder.group({
      'message': ['', Validators.required],
      'eventId':'',
      'userId':'',
      'eventUserId':'',
      myChoices: new FormArray([])
    });
  }

  ngOnInit() {
    if(this.eventId && this.userId){
    this.cancelForm.controls['userId'].patchValue(this.userId);
    this.cancelForm.controls['eventId'].patchValue(this.eventId);
    this.cancelForm.controls['eventUserId'].patchValue(this.eventUserId);
      this.getFullCancelDetail(this.eventId,this.userId);
    }else{
      this.snackBar.open('something went wrong','',{duration:4000});
      this.dialogRef.close();
    }
  }
  getFullCancelDetail(eventId,userId){
    this.spinner = true;
    this.ListingService.getFullCancelDetail({eventId:eventId,userId:userId,eventUserId:this.eventUserId}).subscribe(
            response => {
          this.spinner = false;
          this.users = response.refundList;
          this.rList=response.refundList;
          this.totalPrice=(response.totalPaid>0)?response.totalPaid:0;
        },
            error => {
          this.spinner = false;
          this.errorMessage = <any>error;
          this.snackBar.open('something went wrong','',{duration:4000});
        }
    );
  }

  handleChange(evt){
    if (evt.value==1) {
      this.isChecked=true;
      this.rList.forEach(function(item){
        item.selected = true;
      });
    } else {
      this.isChecked=false;
      this.rList.forEach(function(item){
        item.selected = false;
      });
    }
    this.changeStatus();
  }


//  changeStatus(){
//
//    this.cardPaid=0;this.checkPaid=0;
//    var discounts=0;var price=0;var tot=0;var bal=0;var bal1=0;var card=0;var check=0;
//    var txt;
//    var tprice=this.totalPrice;
//    var datas  = this.rList.filter(function (data) {  return data.selected == true });
//    for (var i = 0; i < datas.length; i++) {
//      txt=datas[i].id.split('_');
//      if(txt[0]=='user'){
//        if(tprice>0){
//          bal1=tprice-(parseFloat(datas[i].price)-parseFloat(datas[i].discountApplied));
//          console.log('b'+bal1+'totalprice'+tprice+'price'+datas[i].price);
//          if(bal1>0){
//
//          }else{
//            for (var j = 0; j < this.users.length; j++) {
//              tot=(parseFloat(this.users[j].price)-parseFloat(this.users[j].discountApplied));
//
//            }
//          }
//        }
//
//        tprice=parseFloat(this.totalPrice)-parseFloat(this.discount);
//        console.log(tprice);
//        //price=price+parseFloat(datas[i].price);
//        //bal=price-this.discount;
//        //if(bal>0){
//        //  card=0;check=0;
//        //  this.resultArray=[];
//        //  for (var j = 0; j < datas.length; j++) {
//        //    txt=datas[j].id.split('_');
//        //    if(txt[0]=='user' && datas[j].transStatus==1 && (parseFloat(datas[j].price)-parseFloat(datas[j].discountApplied))>0){
//        //      tot=(parseFloat(datas[j].price)-parseFloat(datas[j].discountApplied));
//        //        if(bal>0){
//        //          bal1=bal-tot;
//        //          if(bal1>=0){
//        //            bal=bal-tot;
//        //            if(datas[j].transType=='Card' ){
//        //              card=card+(tot);
//        //              this.resultArray.push({"userId":txt[1], "amount":tot});
//        //            }else if(datas[j].transType=='Check'){
//        //              check=check+(tot);
//        //              this.resultArray.push({"userId":txt[1], "amount":tot});
//        //            }
//        //          }
//        //          if(bal1<0){
//        //            if(datas[j].transType=='Card' ){
//        //              this.resultArray.push({"userId":txt[1], "amount":Math.abs(tot)});
//        //              this.cardPaid=parseFloat(this.cardPaid)+(Math.abs(tot));
//        //            }else if(datas[j].transType=='Check'){
//        //              this.checkPaid=parseFloat(this.checkPaid)+(Math.abs(tot));
//        //              this.resultArray.push({"userId":txt[1], "amount":Math.abs(tot)});
//        //            }
//        //            bal=0;
//        //          }
//        //        }
//        //
//        //
//        //
//        //    }
//        //  }
//        //}
//      }else{
//        if(datas[i].transType=='Card' && datas[i].transStatus==1){
//          this.cardPaid=parseFloat(this.cardPaid)+(parseFloat(datas[i].price)-parseFloat(datas[i].discountApplied));
//        }else if(datas[i].transType=='Check' && datas[i].transStatus==1){
//          this.checkPaid=parseFloat(this.checkPaid)+(parseFloat(datas[i].price)-parseFloat(datas[i].discountApplied));
//        }
//      }
//    }
//    this.cardPaid=parseFloat(this.cardPaid)+card;
//    this.checkPaid=parseFloat(this.checkPaid)+check;
//    if(datas.length<this.users.length){
//      this.isChecked=false;
//    }else{
//      this.isChecked=true;
//    }
//console.log(this.resultArray);
//  }

  changeStatus(){
    this.cardPaid=0;this.checkPaid=0;
    //console.log(this.rList);
    var datas  = this.rList.filter(function (data) {  return data.selected == true });
    for (var i = 0; i < datas.length; i++) {
      if(datas[i].transType=='Card' && datas[i].transStatus==1){
        this.cardPaid=parseFloat(this.cardPaid)+(parseFloat(datas[i].price)-parseFloat(datas[i].discountApplied));
      }else if(datas[i].transType=='Check' && datas[i].transStatus==1){
        this.checkPaid=parseFloat(this.checkPaid)+(parseFloat(datas[i].price)-parseFloat(datas[i].discountApplied));
      }
    }

    if(datas.length<this.users.length){
      this.isChecked=false;
    }else{
      this.isChecked=true;
    }

  }

  cancelUser(){

    const refundArray = <FormArray>this.cancelForm.controls.myChoices;
    while (refundArray.length !== 0) {
      refundArray.removeAt(0)
    }
    var datas  = this.rList.filter(function (data) {  return data.selected == true });
    for (var i = 0; i < datas.length; i++) {
      refundArray.push(new FormControl(datas[i].id));
    }

    if (this.cancelForm.valid) {
      this.spinner = true;
      this.ListingService.fullCancel(this.cancelForm.value)
          .subscribe(
              response => {
            this.spinner = false;
            if(response.status) {
              this.snackBar.open(response.message, '', {duration: 4000});
              this.dialogRef.close(response);
            }else {
              this.spinner = false;
              this.snackBar.open(response.message, '', {duration: 4000});
            }
          },
              error => {
            this.spinner = false;
            this.errorMessage = <any>error;
          }
      );
    }
  }
  toggleSelect = function(event){
    this.allCheck = event.target.checked;
    this.rList.forEach(function(item){
      item.selected = event.target.checked;
    });
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/admin-full-cancel/admin-full-cancel.component.ts